import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';
import * as fromDashboardActions from 'src/app/state-management/actions/dashboard.action';
import * as fromSosActions from 'src/app/state-management/actions/advanced_sos.actions';
import * as fromUserActions from 'src/app/state-management/actions/manage-user.action';
import * as fromAdvancedSoSActions from 'src/app/state-management/actions/advanced_sos.actions';

import { BehaviorSubject, Observable, Subject, timer, throwError } from 'rxjs';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import {
  retryWhen,
  delayWhen,
  take,
  catchError,
  takeUntil,
  filter,
} from 'rxjs/operators';

import 'firebase/app';
import { HttpClient } from '@angular/common/http';
import { AumyeDashboardService } from '../aumye-dashboard.service';
import { environment } from 'src/app/environments/environments';
import { WebSocketTokenValidatorService } from './web-socket-token-validator.service';
import {
  IDashboardState,
  INotifications,
} from 'src/app/state-management/states/aumye-dashboard.state';
import { IIncidents } from 'src/app/models/incident';
import { Actions, ofType } from '@ngrx/effects';
import { EPassPrinterService } from '../epass-printer-service.service';
import { Visitor } from 'src/app/models/visitor';
import { Capacitor } from '@capacitor/core';
import { BrouserPrinter } from '../printer/printer';
import {
  UserDetailsToken,
  EncryptionService,
} from '../Encryption/encryption.service';

export interface IClientNotifications {
  OrgId: string;
  FlowType: string;
  Id: string;
  MessageTitle: string;
  MessageBody: string;
  MessageData: string;
  MessageLink: string;
}
export interface IncidentDetails {
  incidentList: IIncidents[];
  criticalIncidentList: IIncidents[];
  mediumIncidentList: IIncidents[];
  lowIncidentList: IIncidents[];
  noIncidentList: IIncidents[];
  recentActivityIncidentList: IIncidents[];
  // Add other properties as needed
}
@Injectable({
  providedIn: 'root',
})
export class AumyeFirebaseRealtimeDbService implements OnInit, OnDestroy {
  orgId: string = null;
  userId: string = null;
  role: string = null;
  url = '/orgId/';
  isFirebaseConnect: boolean = false;
  wssLink = localStorage.getItem('WebsocketToken');
  baseServerURL = environment.apiUrl;
  printerAllowed = environment.printerAllowed;
  loggedUser: UserDetailsToken;

  private socket$: WebSocketSubject<any>;
  private connectionStatus = new Subject<boolean>();

  dashboardState$: Observable<IDashboardState>;
  dashboardData: IDashboardState;
  private destroyed$ = new Subject<void>();

  constructor(
    private db: AngularFireDatabase,
    private toastr: ToastrService,
    private store: Store<IAumyeState>,
    private httpclient: HttpClient,
    private tokenValidator: WebSocketTokenValidatorService,
    private actions$: Actions,
    private printerService: EPassPrinterService,
    private brouserPrinter: BrouserPrinter,
    private encryptionService: EncryptionService
  ) {
    this.loggedUser = this.encryptionService.getCurrentUser();
    if (this.loggedUser) this.orgId = this.loggedUser.organizationID;
    if (this.orgId != null || this.isFirebaseConnect) {
      this.isFirebaseConnect = true;
      // this.requestPermissionForSecurity();
      // this.UpdateUserPolls();
      // this.updateNoticeBoard();
      // this.checNewTokenAllocation();
    }
    this.dashboardState$ = this.store.select('aumyeDashboardState');
    this.dashboardState$.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.dashboardData = data;
    });
  }
  ngOnInit(): void {
    this.loggedUser = this.encryptionService.getCurrentUser();
    this.orgId = this.loggedUser.organizationID;
    this.userId = this.loggedUser.userID;
    this.role = this.loggedUser.role;
  }
  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
  initRealTime() {}
  checkForMessage() {}
  connect(url: string): Observable<any> {
    if (!this.socket$ || this.socket$.closed) {
      this.socket$ = webSocket({
        url: url,
        openObserver: {
          next: () => {
            console.log('WebSocket connection established', new Date());
            this.connectionStatus.next(true);
          },
          error: (err) => this.handleError(err),
        },
        closeObserver: {
          next: () => {
            console.log('WebSocket connection closed');
            this.connectionStatus.next(false);
          },
          error: (err) => this.handleError(err),
        },
        // messageObserver: {
        //   error: (err) => this.handleError(err)
        // }
      });

      return this.socket$.pipe(
        catchError((err) => {
          this.handleError(err);
          return throwError(err);
        }),
        retryWhen((errors) =>
          errors.pipe(
            delayWhen(() => timer(1000)), // Wait 1 second before retry
            take(5) // Maximum 5 retry attempts
          )
        )
      );
    }

    return this.socket$;
  }
  sendMessage(message: any): void {
    if (this.socket$ && !this.socket$.closed) {
      this.socket$.next(message);
    } else {
      console.error('WebSocket is not open. Cannot send message.');
    }
  }

  close(): void {
    if (this.socket$) {
      this.socket$.complete();
    }
  }
  getConnectionStatus(): Observable<boolean> {
    return this.connectionStatus.asObservable();
  }
  private handleError(err: any): void {
    console.error('WebSocket Error:', err);
    switch (err.type) {
      case 'open':
        console.log('Connection could not be established');
        break;
      case 'close':
        console.log('Connection was closed');
        break;
      case 'message':
        console.log('Error in message processing');
        break;
      default:
        console.log('Unknown WebSocket error');
    }
  }
  isRealtimeInitiated = false;
  validateWebsocketToken() {
    if (this.isRealtimeInitiated) {
      return;
    }
    this.wssLink = localStorage.getItem('WebsocketToken');
    if (this.wssLink) {
      const validationResult = this.tokenValidator.validateToken(this.wssLink);
      if (validationResult.isValid) {
        // this.wsService.connect(url);
        this.SocketMessages();
      } else {
        console.error(validationResult.error);
      }
    }

    this.getConnectionStatus().subscribe((isConnected) => {
      console.log('Connected:', isConnected);
      this.isRealtimeInitiated = isConnected;
    });
  }
  public updateVisitors() {
    this.store.dispatch(new fromDashboardActions.UpdateVisitorList({}));
  }
  public updateIncidentById(message: IClientNotifications) {
    this.store.dispatch(new fromDashboardActions.UpdateIncidentById(message));
  }
  public getAdvancedSos(message: IClientNotifications) {
    this.store.dispatch(
      new fromAdvancedSoSActions.GetAdvancedSOSUpdates(message)
    );
  }
  public updateRequestById(message: IClientNotifications) {
    this.store.dispatch(new fromDashboardActions.UpdateRequestById(message));
  }
  public updateClaimById(message: IClientNotifications) {
    this.store.dispatch(new fromDashboardActions.UpdateClaimById(message));
  }
  public updateComplaintById(message: IClientNotifications) {
    this.store.dispatch(new fromDashboardActions.UpdateComplaintById(message));
  }
  public updateVisitorById(message: IClientNotifications) {
    this.store.dispatch(new fromDashboardActions.UpdateVisitorById(message));
  }
  public updateEmployeeAttendanceById(message: IClientNotifications) {
    this.store.dispatch(new fromDashboardActions.FetchEmployees({}));
  }
  public addNewIncidentById(message: IClientNotifications) {
    this.store.dispatch(new fromDashboardActions.AddNewIncident(message));
  }
  public addNewVisitorById(message: IClientNotifications) {
    this.store.dispatch(new fromDashboardActions.AddNewVisitor(message));
  }
  public addNewComplaintById(message: IClientNotifications) {
    this.store.dispatch(new fromDashboardActions.AddNewComplaint(message));
  }
  public addNewRequestById(message: IClientNotifications) {
    this.store.dispatch(new fromDashboardActions.AddNewRequest(message));
  }
  public addNewClaimById(message: IClientNotifications) {
    this.store.dispatch(new fromDashboardActions.AddNewClaim(message));
  }
  public addNewUserById(message: IClientNotifications) {
    this.store.dispatch(new fromDashboardActions.AddNewUser(message));
  }
  public getCommunityPosts(message: IClientNotifications) {
    this.store.dispatch(new fromDashboardActions.GetNoticeBoardPosts(message));
  }
  public updateIncidents() {
    this.store.dispatch(new fromDashboardActions.UpdateIncidentList({}));
  }
  public updateEmployee() {
    this.store.dispatch(new fromDashboardActions.UpdateEmployees({}));
  }
  public updateUserComplaint() {
    this.store.dispatch(new fromDashboardActions.GetComplaintsTickets({}));
    this.store.dispatch(new fromDashboardActions.GetClaimTickets({}));
    this.store.dispatch(new fromDashboardActions.GetRequestsTickets({}));
  }
  public UpdateSosData() {
    this.store.dispatch(new fromSosActions.GetAdvancedSOSRequestsResponds({}));
  }
  public UpdateUser() {
    this.store.dispatch(new fromUserActions.UserList({}));
  }
  public UpdateEmployess() {
    //
  }
  public UpdateComment() {
    this.store.dispatch(new fromDashboardActions.PostUserCommentSuccess({}));
  }
  public SocketMessages() {
    try {
      this.connect(this.wssLink).subscribe({
        next: (message) => {
          this.FormatSocketMessage(message);
        },
        error: (err) => {
          console.error('WebSocket connection error', err);
        },
        complete: () => {
          console.log('WebSocket connection completed');
        },
      });
    } catch (e) {
      console.log('json');
    }
  }
  // Function to save a new notification
  saveNotification(message: IClientNotifications): void {
    // Get existing notifications from localStorage
    let notification: INotifications = {
      notificationOrg: message.OrgId,
      notificationTitle: message.MessageTitle,
      notificationBody: message.MessageBody,
      notificationFlowType: message.FlowType,
      notificationId: message.Id,
      notificationPeopleId: message.MessageData
        ? JSON.parse(message.MessageData)
        : [],
      timestamp: new Date(),
      read: false,
      type: 'INFO',
    };
    const existingNotifications = this.getNotificationsFromStorage();

    // Add the new notification to the array
    existingNotifications.unshift(notification);

    // Save the updated array back to localStorage
    localStorage.setItem(
      'userNotifications',
      JSON.stringify(existingNotifications)
    );
    this.store.dispatch(
      new fromDashboardActions.AddNewNotification(notification)
    );
  }
  // Function to get notifications from localStorage
  getNotificationsFromStorage(): INotifications[] {
    const storedNotifications = localStorage.getItem('userNotifications');
    return storedNotifications ? JSON.parse(storedNotifications) : [];
  }
  private FormatSocketMessage(message: IClientNotifications) {
    if (this.orgId == null || this.userId == null || this.loggedUser == null) {
      this.loggedUser = this.encryptionService.getCurrentUser();
      this.orgId = this.loggedUser.organizationID;
      this.userId = this.loggedUser.userID;
    }
    if (message.OrgId === this.orgId) {
      const flow = this.getFlowType(message?.Id?.toLowerCase());
      if (
        message.FlowType != 'Employee Attendance' &&
        message.FlowType != 'Mobile OTP' &&
        message?.MessageBody
      ) {
        if (
          (message.FlowType === 'New Visitor' ||
            message.FlowType === 'Update Visitor') &&
          message.MessageBody
        ) {
          const hostIds: string[] = JSON.parse(message.MessageData);
          if (
            hostIds &&
            hostIds.some((id) => id.toLowerCase() === this.userId.toLowerCase())
          ) {
            // this.saveNotification(message);
          }
        } else {
          // this.saveNotification(message);
        }
      }
      if (message.FlowType === 'Incident Update') {
        switch (flow) {
          case 'Incident':
            this.updateIncidentById(message);
            break;
          case 'Complaints':
            this.updateComplaintById(message);
            break;
          case 'Claims':
            this.updateClaimById(message);
            break;
          case 'Requests':
            this.updateRequestById(message);
            break;
          case 'Visitor':
            this.updateVisitorById(message);
            break;
          case 'NoticeBoard':
            //  this.updateNoticeBoardById(message);
            break;
          default:
            console.warn('Unknown flow type for ID:', message.Id);
        }
      } else if (message.FlowType === 'Incident Removed') {
        switch (flow) {
          case 'Incident':
            this.store.dispatch(
              new fromDashboardActions.RemoveIncidentById(message)
            );
            break;
          case 'Complaints':
            this.store.dispatch(
              new fromDashboardActions.RemoveComplaintsById(message)
            );
            break;
          case 'Claims':
            this.store.dispatch(
              new fromDashboardActions.RemoveClaimsById(message)
            );
            break;
          case 'Requests':
            this.store.dispatch(
              new fromDashboardActions.RemoveServiceById(message)
            );
            break;
        }
      } else if (message.FlowType === 'New Incident') {
        this.addNewIncidentById(message);
      } else if (message.FlowType === 'Comment') {
        switch (flow) {
          case 'Incident':
            this.updateIncidentById(message);
            break;
          case 'Complaints':
            this.updateComplaintById(message);
            break;
          case 'Claims':
            this.updateClaimById(message);
            break;
          case 'Requests':
            this.updateRequestById(message);
            break;
          case 'Visitor':
            this.updateVisitorById(message);
            break;
          case 'NoticeBoard':
            this.getCommunityPosts(message);
            break;
          default:
            console.warn('Unknown flow type for ID:', message.Id);
        }
      } else if (message.FlowType === 'Auto Responder') {
        this.getAdvancedSos(message);
        this.updateIncidentById(message);
      } else if (message.FlowType === 'Request SOS') {
        this.getAdvancedSos(message);
        this.addNewIncidentById(message);
      } else if (
        message.FlowType === 'New Complain' ||
        message.FlowType === 'New Claim' ||
        message.FlowType === 'New Service Request' ||
        message.FlowType === 'New HouseKeeping' ||
        message.FlowType === 'New Leave' ||
        message.FlowType === 'New Vendor' ||
        message.FlowType === 'New Electrical' ||
        message.FlowType === 'New Plumbing' ||
        message.FlowType === 'New Horticulture/Landscaping' ||
        message.FlowType === 'New Support' ||
        message.FlowType === 'New Other'
      ) {
        if (message.FlowType === 'New Complain') {
          this.addNewComplaintById(message);
        } else if (message.FlowType === 'New Claim') {
          this.addNewClaimById(message);
        } else {
          this.addNewRequestById(message);
        }
      } else if (message.FlowType === 'Employee Attendance') {
        this.updateEmployeeAttendanceById(message);
      } else if (message.FlowType === 'New User') {
        this.addNewUserById(message);
      } else if (message.FlowType === 'Update User') {
        this.addNewUserById(message);
      } else if (message.FlowType === 'New Visitor') {
        this.updateVisitorById(message);
      } else if (message.FlowType === 'Update Visitor') {
        if (
          message.MessageBody.includes('has recheckded in') ||
          message.MessageBody.includes('has checked in')
        ) {
          // Listen for the UpdateVisitorByIdSuccess action
          const subscription = this.actions$
            .pipe(
              ofType(
                fromDashboardActions.DashboardActionTypes
                  .UPDATE_VISITOR_BY_ID_SUCCESS
              ),
              take(1) // Take only the first emission to avoid multiple prints
            )
            .subscribe({
              next: () => {
                const visitor: Visitor =
                  this.dashboardData.visitorDetails.visitorList.find(
                    (x) =>
                      x.visitorID.toLowerCase() === message.Id.toLowerCase()
                  );
                if (visitor) {
                  this.printVisitorEPass(visitor);
                } else {
                  console.error('No Visitor Found');
                }
              },
              complete: () => {
                // Clean up subscription - though take(1) will auto-complete after one emission
                subscription.unsubscribe();
              },
            });
          this.updateVisitorById(message);
        } else {
          this.updateVisitorById(message);
        }
      } else if (message.FlowType === 'Community Post') {
        this.getCommunityPosts(message);
      }
    }
  }
  private printVisitorEPass(visitorData: Visitor) {
    this.role = this.loggedUser.role;
    // if (this.orgId === '7cf3b37d-2605-47ca-9876-30617369260d') {
    if (this.orgId === 'bdd8a821-c025-4f1d-88c2-400607155851') {
      this.printerService
        .printVisitorEPass(visitorData)
        .then((success) => {
          if (success) {
            console.log('E-Pass printed successfully');
          } else {
            console.error('Failed to print E-Pass');
          }
        })
        .catch((error) => {
          console.error('Error occurred while printing E-Pass:', error);
        });
    } else if (
      this.printerAllowed.includes(this.orgId) &&
      Capacitor.getPlatform() === 'android' &&
      this.role === 'kiosk'
    ) {
      this.brouserPrinter.print(visitorData);
    }
  }
  private getFlowType(id: string): string {
    const incidentLists: (keyof IncidentDetails)[] = [
      'incidentList',
      'criticalIncidentList',
      'mediumIncidentList',
      'lowIncidentList',
      'noIncidentList',
      'recentActivityIncidentList',
    ];
    const incidentDetails = this.dashboardData.incidentDetails;
    for (const listName of incidentLists) {
      if (
        incidentDetails[listName].some((incident) => incident.incidentId === id)
      ) {
        return 'Incident';
      }
    }

    // Check Visitor Details
    if (
      this.dashboardData.visitorDetails.visitorList?.some(
        (visitor) => visitor.visitorID === id
      )
    ) {
      return 'Visitor';
    }
    // Check Notice Board
    if (
      this.dashboardData.noticeBoardPosts?.some(
        (notice) => notice.postId === id
      )
    ) {
      return 'NoticeBoard';
    }

    // Check Complaints Details
    if (
      this.dashboardData.complaintsTickets?.some(
        (complain) => complain.complainId === id
      )
    ) {
      return 'Complaints';
    }

    // Check Claims Details
    if (
      this.dashboardData.claimTickets?.some((claim) => claim.complainId === id)
    ) {
      return 'Claims';
    }

    // Check Service Requests Details
    if (
      this.dashboardData.requestsTickets?.some(
        (request) => request.complainId === id
      )
    ) {
      return 'Requests';
    }

    return 'not_found';
  }
  // this.toastr.success('Respond Success', 'AumYe Emergency', {
  //   closeButton: true,
  //   timeOut: 2000,
  //   progressBar: true,
  //   enableHtml: true,
  //   tapToDismiss: true,
  // });
  deserializeSocketModel(data: any): SocketModel {
    const model = new SocketModel();
    model.Type = data.Type || '';
    model.Bar = data.Bar || '';
    model.OrgId = data.OrgId ?? null;
    model.UserId = data.UserId ?? null;
    model.Title = data.Title ?? null;
    model.Data = data.Data ?? null;
    return model;
  }
  fetchRealUpdate() {
    this.db
      .list('/Update')
      .valueChanges()
      .subscribe((data) => {
        console.log(data, 'Incidents data');
      });
  }
  sendRealTimeData(data: any) {
    const dbRef = this.db.list('Update');
    dbRef
      .push(data)
      .then(() => {
        console.log('Data sent to Realtime Database successfully');
      })
      .catch((error) => {
        console.log('Error sending data to Realtime Database:', error);
      });
  }
  sendRealTimeMessage(data: any) {
    const dbRef = this.db.list('Message');
    dbRef
      .push(data)
      .then(() => {
        console.log('Data sent to Realtime Database successfully');
      })
      .catch((error) => {
        console.log('Error sending data to Realtime Database:', error);
      });
  }
  fetchRealTimeMessage() {
    this.db
      .list(`user_locations/${this.userId}/currentLocation`)
      .valueChanges()
      .subscribe((data) => {
        this.toastr.success(JSON.stringify(data));
      });
  }
  fetchRealTimeData() {
    this.db
      .list('/Update')
      .valueChanges()
      .subscribe((data) => {
        return data;
      });
  }
  fetchFirebaseMessage() {
    this.db
      .list('/Update')
      .valueChanges()
      .subscribe((data) => {
        console.log(data, 'Incidents data');
        //this.dialog.open(this.IncidentAlert);
        this.toastr.success(JSON.stringify(data));
      });
  }
  updateLocation(userId: string, lat: number, lng: number) {
    this.db.object(`user_locations/${userId}`).set({ lat, lng });
  }

  getLocationUpdates(userId: string) {
    return this.db.object(`user_locations/${userId}`).valueChanges();
  }
  deleteValues(path: string) {
    this.db
      .list(path)
      .snapshotChanges()
      .subscribe((snapshot) => {
        snapshot.forEach((item) => {
          const key = item.key;
          const value = item.payload.val();
          if (key) {
            this.db
              .list(path)
              .remove(key)
              .then(() => {
                console.log(`Data with key '${key}' has been deleted.`);
              })
              .catch((error) => {
                console.error('Error deleting data:', error);
              });
          }
        });
      });
  }
  currentMessage = new BehaviorSubject(null);
  requestPermissionForSecurity() {
    const path = 'Organizations/' + this.orgId + '/' + this.role;
    this.db
      .list(path)
      .valueChanges()
      .subscribe((data) => {
        if (data && data.length > 0) {
          const jsonStr = JSON.stringify(data);
          const jsonArray = JSON.parse(jsonStr) as any[];
          if (jsonArray && jsonArray.length > 0) {
            const firstElement = jsonArray[0];
            const title = firstElement.Title;
            if (title != null) {
              this.showNotification(title, firstElement.Body);
              this.removeNotification(path);
              // this.store.dispatch(
              //   new fromDashboardActions.UpdateIncidentList({})
              // );
              // this.store.dispatch(
              //   new fromDashboardActions.UpdateVisitorList({})
              // );
            }
          }
        }
      });
  }
  showNotification(title: string, body: string) {
    new Notification(title, { body });
  }
  deleteActiveUser() {
    if (!(this.userId && this.orgId)) {
      this.loggedUser = this.encryptionService.getCurrentUser();
      this.orgId = this.loggedUser.organizationID;
      this.userId = this.loggedUser.userID;
    }
    let path = 'Organizations/' + this.orgId + '/ActiveUsers/' + this.userId;
    this.db
      .list(path)
      .snapshotChanges()
      .subscribe((snapshot) => {
        snapshot.forEach((item) => {
          const key = item.key;
          const value = item.payload.val();
          if (key) {
            this.db
              .list(path)
              .remove(key)
              .then(() => {})
              .catch((error) => {});
          }
        });
      });
  }
  //Update Location
  FirebaseUpdateLocation(lat: string, long: string) {
    const dataPath =
      'Organizations/' +
      this.orgId +
      '/AdvanceSOS/RespondedUsersLocation/ActiveUsers/' +
      this.userId +
      '/Currentlocation';
    this.db
      .object(dataPath)
      .valueChanges()
      .pipe(take(1))
      .subscribe((userData: any) => {
        if (userData) {
          const key = Object.keys(userData)[0];
          const orgUser: FirebaseLocatins = {
            latitude: userData[key].latitude,
            longitude: userData[key].longitude,
          };
          const updatedLocationData: FirebaseLocatins = {
            ...orgUser,
          };

          const deserializedData = this.deserialize(
            updatedLocationData,
            FirebaseLocatins
          );
          this.db.object(dataPath).remove();
          const uniqueKey = this.db.list(dataPath).push(deserializedData).key;
        }
      });
  }
  //Insert Location
  FirebaseInsertLocation(lat: string, long: string) {
    const dataPath =
      'Organizations/' +
      this.orgId +
      '/AdvanceSOS/RespondedUsersLocation/ActiveUsers/' +
      this.userId +
      '/Currentlocation';
    this.db
      .object(dataPath)
      .valueChanges()
      .pipe(take(1))
      .subscribe((userData: any) => {
        if (userData) {
          const key = Object.keys(userData)[0];
          const orgUser: FirebaseLocatins = {
            latitude: lat,
            longitude: long,
          };
          const updatedLocationData: FirebaseLocatins = {
            ...orgUser,
          };

          const deserializedData = this.deserialize(
            updatedLocationData,
            FirebaseLocatins
          );
          this.db.object(dataPath).remove();
          const uniqueKey = this.db.list(dataPath).push(deserializedData).key;
        }
      });
  }
  AddUserToken(Token: string) {
    const dataPath = `UserToken`;
    this.db
      .object(dataPath)
      .valueChanges()
      .pipe(take(1))
      .subscribe((TokenData: any) => {
        if (TokenData) {
          const key = Object.keys(TokenData)[0];
          const orgUserTokens: FirebaseFCMS = {
            OrgID: TokenData[key].OrgID,
            UserToken: TokenData[key].UserToken,
            UserID: TokenData[key].UserID,
          };
          const TokenizeData: FirebaseFCM = {
            ...orgUserTokens,
          };
          const deserializedData = this.deserialize(TokenizeData, FirebaseFCMS);
          if (this.userId !== TokenData[key].UserID) {
            const uniqueKey = this.db.list(dataPath).push(deserializedData).key;
          } else {
            const uniqueKey = this.db.list(dataPath).push(deserializedData).key;
          }
        } else {
          const orgUserTokens: FirebaseFCMS = {
            OrgID: this.orgId,
            UserToken: Token,
            UserID: this.userId,
          };
          const TokenizeData: FirebaseFCM = {
            ...orgUserTokens,
          };
          const deserializedData = this.deserialize(TokenizeData, FirebaseFCMS);
          const uniqueKey = this.db.list(dataPath).push(deserializedData).key;
        }
      });
  }
  //Get Poll
  UpdateUserPolls() {
    const path =
      'Organizations/' + this.orgId + '/ActiveUsers/' + this.userId + '/Poll';
    this.db
      .list(path)
      .valueChanges()
      .subscribe((data) => {
        if (data && data.length > 0) {
          this.store.dispatch(new fromDashboardActions.GetUserPolls({}));
          this.removeReadPoll();
        }
      });
  }
  //Deleted Read Poll
  removeReadPoll() {
    const path =
      'Organizations/' + this.orgId + '/ActiveUsers/' + this.userId + '/Poll';
    this.db
      .object(path)
      .valueChanges()
      .pipe(take(1))
      .subscribe((userData: any) => {
        if (userData) {
          const key = Object.keys(userData)[0];
          this.db.object(path).remove();
        }
      });
  }
  //Get Noticeboard
  updateNoticeBoard() {
    const path =
      'Organizations/' +
      this.orgId +
      '/ActiveUsers/' +
      this.userId +
      '/NoticeBoard';
    this.db
      .list(path)
      .valueChanges()
      .subscribe((data) => {
        if (data && data.length > 0) {
          this.store.dispatch(new fromDashboardActions.GetNoticeBoardPosts({}));
          this.removeNoticeBoard();
        }
      });
  }
  //Remove Notice board
  removeNoticeBoard() {
    const path =
      'Organizations/' +
      this.orgId +
      '/ActiveUsers/' +
      this.userId +
      '/NoticeBoard';
    this.db
      .object(path)
      .valueChanges()
      .pipe(take(1))
      .subscribe((userData: any) => {
        if (userData) {
          const key = Object.keys(userData)[0];
          this.db.object(path).remove();
        }
      });
  }
  updateUserDetails() {
    const path = 'Organizations/' + this.orgId + '/ActiveUsers/' + this.userId;
    this.db
      .list(path)
      .valueChanges()
      .subscribe((data) => {
        if (data && data.length > 0) {
          this.isFirebaseConnect == true;
          const jsonStr = JSON.stringify(data);
          const jsonArray = JSON.parse(jsonStr) as any[];
          if (jsonArray && jsonArray.length > 0) {
            const userid = jsonArray[0].UserID?.toString();
            if (userid != null) {
              this.store.dispatch(new fromDashboardActions.GetUserList({}));
              this.removeUserDetails();
            }
          }
        }
      });
  }
  removeUserDetails() {
    const dataPath =
      'Organizations/' + this.orgId + '/ActiveUsers/' + this.userId;
    this.db
      .object(dataPath)
      .valueChanges()
      .pipe(take(1))
      .subscribe((userData: any) => {
        if (userData) {
          const key = Object.keys(userData)[0];
          const orgUser: FirebaseOrgUser = {
            Status: userData[key].Status,
            FullName: userData[key].FullName,
            LastLoggedIn: userData[key].LastLoggedIn,
            Visitor: userData[key].visitor ? userData[key].visitor : null,
            incidentid: userData[key].incidentid
              ? userData[key].incidentid
              : null,
          };
          const updatedData: FirebaseOrgUser = {
            ...orgUser,
          };

          const deserializedData = this.deserialize(
            updatedData,
            FirebaseOrgUsers
          );
          this.db.object(dataPath).remove();
          const uniqueKey = this.db.list(dataPath).push(deserializedData).key;
        }
      });
  }
  removeNotification(dataPath: string): void {
    this.db
      .object(dataPath)
      .valueChanges()
      .pipe(take(1))
      .subscribe((userData: any) => {
        if (userData) {
          const key = Object.keys(userData)[0];
          const orgUser: FCMNotification = {
            Title: userData[key].Title,
            Body: userData[key].Body,
          };
          const updatedData: FCMNotification = {
            ...orgUser,
          };

          const deserializedData = this.deserialize(
            updatedData,
            FCMNotifications
          );
          this.db.object(dataPath).remove();
          // const uniqueKey = this.db.list(dataPath).push(deserializedData).key;
        }
      });
  }
  checNewTokenAllocation() {
    const path = 'AndroidToken';
    let apiURL = this.baseServerURL + 'UpdateDeviceToken';
    this.db
      .list(path)
      .valueChanges()
      .subscribe((data) => {
        if (data && data.length > 0) {
          this.httpclient
            .post(apiURL, true, { responseType: 'text' })
            .subscribe(
              (res: any) => {
                console.log('Device token updated successfully.');
              },
              (error: any) => {
                console.error('Error updating device token:', error);
              }
            );
        }
      });
  }
  deserialize<T>(jsonObject: any, FirebaseOrgUser: { new (): T }): T {
    const instance = new FirebaseOrgUser();
    Object.assign(instance, jsonObject);
    return instance;
  }
}

interface FirebaseOrgUser {
  Status: string;
  FullName: string;
  LastLoggedIn: string;
  Visitor?: string;
  incidentid?: string;
  UserID?: string;
}
interface FirebaseFCM {
  OrgID: string;
  UserID: string;
  UserToken: string;
}
interface FCMNotification {
  Body: string;
  Title: string;
}
interface FirebaseLocation {
  latitude: string;
  longitude: string;
}
export interface SocketModel {
  Type: string;
  Bar: string;
  OrgId: string | null;
  UserId: string | null;
  Title: string | null;
  Data: string | null;
}
class FirebaseOrgUsers {
  Status: string = '';
  FullName: string = '';
  LastLoggedIn: string = '';
  Visitor?: string = null;
  incidentid?: string = null;
  UserID?: string = null;
}
class FirebaseFCMS {
  OrgID: string = '';
  UserID: string = '';
  UserToken: string = '';
}
class FirebaseLocatins {
  latitude: string = '';
  longitude: string = '';
}
class FCMNotifications {
  Body: string = '';
  Title: string = '';
}
export class SocketModel {
  Type: string;
  Bar: string;
  orgId: string | null;
  userId: string | null;
  Title: string | null;
  Data: string | null;
}
